/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FileFormatXmlIcon16Light } from './FileFormatXmlIcon16Light';
import { FileFormatXmlIcon16Regular } from './FileFormatXmlIcon16Regular';
import { FileFormatXmlIcon16Solid } from './FileFormatXmlIcon16Solid';
import { FileFormatXmlIcon20Light } from './FileFormatXmlIcon20Light';
import { FileFormatXmlIcon20Regular } from './FileFormatXmlIcon20Regular';
import { FileFormatXmlIcon20Solid } from './FileFormatXmlIcon20Solid';
import { FileFormatXmlIcon24Regular } from './FileFormatXmlIcon24Regular';
import { FileFormatXmlIcon24Solid } from './FileFormatXmlIcon24Solid';
import { FileFormatXmlIcon32Regular } from './FileFormatXmlIcon32Regular';
import { FileFormatXmlIcon64Regular } from './FileFormatXmlIcon64Regular';
var sizes = {
    16: {
        light: FileFormatXmlIcon16Light,
        regular: FileFormatXmlIcon16Regular,
        solid: FileFormatXmlIcon16Solid,
    },
    20: {
        light: FileFormatXmlIcon20Light,
        regular: FileFormatXmlIcon20Regular,
        solid: FileFormatXmlIcon20Solid,
    },
    24: {
        regular: FileFormatXmlIcon24Regular,
        solid: FileFormatXmlIcon24Solid,
    },
    32: {
        regular: FileFormatXmlIcon32Regular,
    },
    64: {
        regular: FileFormatXmlIcon64Regular,
    },
};
export var FileFormatXmlIcon = forwardRef('FileFormatXmlIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
